import Vue from 'vue'
import $store from '@/store'

const API_BASE_URL = process.env.API_BASE_URL + '/v1/admin'

export default {
  getUsers(params) {
    return Vue.http.get(API_BASE_URL + '/users', {
      headers: { Authorization: $store.state.auth.token },
      params: params,
    })
  },

  getFreeAccountCreditUsers(params) {
    return Vue.http.get(API_BASE_URL + '/free_account_credit_users', {
      headers: { Authorization: $store.state.auth.token },
      params: params,
    })
  },

  getSignupUsers(params) {
    return Vue.http.get(API_BASE_URL + '/signed_up_artists', {
      headers: { Authorization: $store.state.auth.token },
      params: params,
    })
  },

  approveUser(params) {
    return Vue.http.post(API_BASE_URL + '/approve_user', params, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  denyUser(params) {
    return Vue.http.post(API_BASE_URL + '/deny_user', params, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  disconnectStripe(params) {
    return Vue.http.post(`${API_BASE_URL}/disconnect_stripe`, params, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  toggleViewDirectMessages(params) {
    return Vue.http.post(
      `${API_BASE_URL}/toggle_view_direct_messages`,
      params,
      { headers: { Authorization: $store.state.auth.token } }
    )
  },

  toggleLiveVideo(params) {
    return Vue.http.post(`${API_BASE_URL}/toggle_live_video`, params, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  toggleLiveVideoFree(params) {
    return Vue.http.post(`${API_BASE_URL}/toggle_live_video_free`, params, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  toggleSignInAuthorized(params) {
    return Vue.http.post(`${API_BASE_URL}/toggle_sign_in_authorized`, params, {
      headers: { Authorization: $store.state.auth.token },
    });
  },

  getAlbums(params) {
    return Vue.http.get(API_BASE_URL + '/albums', {
      headers: { Authorization: $store.state.auth.token },
      params: params,
    })
  },

  getProducts(params) {
    return Vue.http.get(API_BASE_URL + '/products', {
      headers: { Authorization: $store.state.auth.token },
      params: params,
    })
  },

  getStreams(params) {
    return Vue.http.get(API_BASE_URL + '/streams', {
      headers: { Authorization: $store.state.auth.token },
      params: params,
    })
  },

  sendGlobalMessage(params) {
    return Vue.http.post(API_BASE_URL + '/send_global_message', params, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  getGlobalStats(params) {
    return Vue.http.get(API_BASE_URL + '/global_stats', {
      headers: { Authorization: $store.state.auth.token },
      params: params,
    })
  },

  getAttendees() {
    return Vue.http.get(`${API_BASE_URL}/attendees`, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  inviteAttendee(params) {
    return Vue.http.get(`${API_BASE_URL}/invite_attendee`, {
      headers: { Authorization: $store.state.auth.token },
      params: params,
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/admin.js